export default "__VITE_ASSET__CNjunyxU__"